"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonClassNames = exports.Button = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
require("./styles.css");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var primary = "border-transparent bg-primary text-primary-content hover:bg-primary-focus disabled:bg-base-200 disabled:text-base-300";
var dangerPrimary = "!bg-error";
var warningPrimary = "!bg-warning";
var secondary = "border-neutral-content text-base-content hover:border-primary-focus hover:text-primary-focus disabled:border-base-200 disabled:text-base-300";
var dangerSecondary = "!border-error hover:!text-error";
var warningSecondary = "!border-warning hover:!text-warning";
var ghost = "border-transparent text-primary hover:text-primary-content hover:bg-primary-focus disabled:hover:bg-transparent disabled:text-base-300";
var dangerGhost = "hover:!bg-error hover:!text-primary-content";
var warningGhost = "hover:!bg-warning hover:!text-primary-content";
var primaryIcon = "fill-primary-content group-disabled:fill-base-300";
var secondaryIcon = "fill-base-content group-hover:fill-primary-focus group-disabled:fill-base-300";
var ghostIcon = "fill-primary group-hover:fill-primary-content group-disabled:fill-base-300";
var dangerPrimaryIcon = "!fill-primary-content";
var dangerSecondaryIcon = "group-hover:!fill-error";
var warningSecondaryIcon = "group-hover:!fill-warning";
var dangerWarningGhostIcon = "group-hover:!fill-primary-content";
var small = "h-6 px-3 py-1 text-xs gap-1";
var medium = "h-9 px-4 py-2 text-sm gap-2";
var large = "h-12 px-6 py-3 text-base gap-3";
var smallIcon = "h-3 w-3";
var mediumIcon = "h-4 w-4";
var largeIcon = "h-6 w-6";
var buttonClassNames = exports.buttonClassNames = {
  primary: primary,
  secondary: secondary,
  ghost: ghost,
  primaryIcon: primaryIcon,
  secondaryIcon: secondaryIcon,
  ghostIcon: ghostIcon,
  small: small,
  medium: medium,
  large: large,
  smallIcon: smallIcon,
  mediumIcon: mediumIcon,
  largeIcon: largeIcon
};
var Button = exports.Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;
  var id = _ref.id,
    label = _ref.label,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "primary" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size,
    Icon = _ref.icon,
    _ref$iconSide = _ref.iconSide,
    iconSide = _ref$iconSide === void 0 ? "left" : _ref$iconSide,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading,
    onClick = _ref.onClick,
    ariaLabel = _ref.ariaLabel,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$danger = _ref.danger,
    danger = _ref$danger === void 0 ? false : _ref$danger,
    _ref$warning = _ref.warning,
    warning = _ref$warning === void 0 ? false : _ref$warning,
    type = _ref.type,
    testId = _ref.testId,
    tabIndex = _ref.tabIndex;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
    id: id,
    ref: ref,
    onClick: onClick,
    type: type,
    disabled: disabled,
    tabIndex: tabIndex,
    "aria-label": ariaLabel || label,
    "data-testid": testId,
    className: (0, _classnames["default"])("flex flex-row items-center border focus:outline-none focus:ring-2 focus:ring-base-content group rounded-full font-semibold justify-center", (_classNames = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, "".concat(primary), variant === "primary"), "".concat(secondary), variant === "secondary"), "".concat(ghost), variant === "ghost"), "".concat(small), size === "small"), "".concat(medium), size === "medium"), "".concat(large), size === "large"), "flex-row-reverse", iconSide === "right"), "loadingButton", isLoading), "w-full", fullWidth), "hover:opacity-80", (danger || warning) && !disabled), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, "".concat(dangerPrimary), danger && variant === "primary" && !disabled), "".concat(dangerSecondary), danger && variant === "secondary" && !disabled), "".concat(dangerGhost), danger && variant === "ghost" && !disabled), "".concat(warningPrimary), warning && variant === "primary" && !disabled), "".concat(warningSecondary), warning && variant === "secondary" && !disabled), "".concat(warningGhost), warning && variant === "ghost" && !disabled))),
    children: [Icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
      className: (0, _classnames["default"])(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(primaryIcon), variant === "primary"), "".concat(secondaryIcon), variant === "secondary"), "".concat(ghostIcon), variant === "ghost"), "".concat(smallIcon), size === "small"), "".concat(mediumIcon), size === "medium"), "".concat(largeIcon), size === "large"), "".concat(dangerPrimaryIcon), danger && variant === "primary" && !disabled), "".concat(dangerSecondaryIcon), danger && variant === "secondary" && !disabled), "".concat(dangerWarningGhostIcon), (danger || warning) && variant === "ghost" && !disabled), "".concat(warningSecondaryIcon), warning && variant === "secondary" && !disabled)),
      color: "currentFill"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "empty:hidden",
      children: label
    })]
  });
});